export default "__VITE_ASSET__nSI8ZLto__"